import React, { useState, useEffect, useMemo, useRef } from "react";
import { Select, Checkbox, message } from "antd";
import { HiOutlineArrowRight } from "react-icons/hi2";
import { FiSearch } from "react-icons/fi";
import { IoChevronDown, IoCheckmark } from "react-icons/io5";
import { FaArrowRightLong } from "react-icons/fa6";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useDispatch, useSelector } from "react-redux";
import {
  clearStatus,
  fetchFormAssignments,
} from "../../../../../redux/ViewForm/viewFormSlice";
import PopupCard from "../../../../Auth/PopupCard";

const { Option } = Select;

const AuthorizeToManageLS2 = ({
  formId,
  onClose,
  projectId: propProjectId,
  formType,
  locationId: propLocationId,
  departmentId: propDepartmentId,
  formAllotmentId: propFormAllotmentId,
}) => {
  const dispatch = useDispatch();
  console.log(formId, "fornidsadadadasgfhgh");
  const authUser = useSelector((state) => state.auth.user);
  const managedForms = useSelector((state) => state.managedForms.managedForms);
  const clientId = authUser?.client_id?._id || authUser?._id;
  const {
    actionLoading,
    success: reduxSuccess,
    error: reduxError,
  } = useSelector((state) => state.viewForm);
  const orgStructureMode = authUser?.orgStructureMode || "location-first";
  const isLocationFirst = orgStructureMode === "location-first";
  const managedFormMatch = useMemo(
    () => managedForms?.find((f) => f.formId === formId) || null,
    [managedForms, formId],
  );
  const resolvedFormAllotmentId =
    propFormAllotmentId ||
    managedFormMatch?._id ||
    managedFormMatch?.formAllotmentId ||
    null;
  const resolvedProjectId =
    propProjectId ||
    managedFormMatch?.projectId?._id ||
    managedFormMatch?.projectId ||
    null;
  const ls1LocationId =
    propLocationId ||
    managedFormMatch?.locationId ||
    authUser?.locationId ||
    null;
  const ls1DepartmentId =
    propDepartmentId ||
    managedFormMatch?.departmentId ||
    authUser?.departmentId ||
    null;
  const isLs2Department = !!ls1LocationId;

  const [loading, setLoading] = useState(false);
  const [ls1Items, setLs1Items] = useState([]); // Locations or Departments (LS1)
  const [selectedLs1Id, setSelectedLs1Id] = useState(null);
  const [items, setItems] = useState([]); // LS2 items (Departments or Locations)
  const [usersByItem, setUsersByItem] = useState({}); // { itemId: users[] }
  const [sections, setSections] = useState([]);
  const [mapping, setMapping] = useState({}); // { itemId: { userId: '', sections: [] } }
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [alreadyAssignedIds, setAlreadyAssignedIds] = useState([]);
  const [popupConfig, setPopupConfig] = useState(null); // { type, title, message }
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const popupTimeoutRef = useRef(null);
  const [usersReady, setUsersReady] = useState(false);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);
  const defaultLs1Id = isLs2Department ? ls1LocationId : ls1DepartmentId;
  const getIdValue = (val) => (typeof val === "object" ? val?._id : val);
  const getSectionIdValues = (vals) =>
    (vals || [])
      .map((v) => (typeof v === "object" ? v?._id : v))
      .filter(Boolean);
  const normalizeSections = (rawSections = []) =>
    rawSections
      .map((section) => ({
        sectionId:
          section.sectionId ||
          section._id ||
          section.id ||
          section.section ||
          section.name,
        name:
          section.title ||
          section.name ||
          section.sectionName ||
          section.section ||
          section.label,
      }))
      .filter((section) => section.sectionId);

  const handleLs1Change = (value) => {
    setSelectedLs1Id(value);
    setSelectedItemIds([]);
    setMapping({});
  };

  const fetchLs1Items = async () => {
    setLoading(true);
    try {
      const ls1Id = getIdValue(defaultLs1Id);
      const ls1List = ls1Id
        ? [
            {
              _id: ls1Id,
              name: isLs2Department ? "Current Location" : "Current Department",
            },
          ]
        : [];
      setLs1Items(ls1List);
      if (!selectedLs1Id && ls1List.length === 1) {
        setSelectedLs1Id(ls1List[0]._id);
      }

      // Fetch Form Sections
      if (formId) {
        const sectionResponse = await getApi({
          apiUrl: resolvedFormAllotmentId
            ? API_URLS.GET_ALLOTTED_SECTIONS(resolvedFormAllotmentId)
            : API_URLS.GET_GET_STANDARD_FORM_Section(formId),
        });
        const rawSections =
          sectionResponse?.data?.sections ||
          sectionResponse?.data?.data ||
          sectionResponse?.data ||
          [];
        setSections(normalizeSections(rawSections));
      }
    } catch (error) {
      console.error("LS2 Data Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLs1Items();
  }, [formId, orgStructureMode, defaultLs1Id, resolvedFormAllotmentId]);

  // Fetch Already Assigned LS2s if formId and resolvedProjectId are present
  useEffect(() => {
    const fetchAssignedLs2 = async () => {
      if (!formId || !resolvedProjectId) return;
      try {
        const ls2Url = API_URLS.GET_LS_TWO(formId, resolvedProjectId);
        const ls2Response = await getApi({ apiUrl: ls2Url });
        const ls2Data = ls2Response?.data?.data || ls2Response?.data || [];

        const assignedIds = [];
        const newMapping = {};

        ls2Data.forEach((allotment) => {
          if (allotment.status === "active") {
            const scopeId = isLs2Department
              ? getIdValue(allotment.departmentId)
              : getIdValue(allotment.locationId);
            const employeeId = getIdValue(allotment.employee);
            const allotmentSections = (allotment.sections || [])
              .map((s) =>
                typeof s === "object" ? s.sectionId || s._id || s.id : s,
              )
              .filter(Boolean);

            if (scopeId && employeeId) {
              assignedIds.push(scopeId);
              newMapping[scopeId] = {
                userId: employeeId,
                sections: allotmentSections,
              };
            }
          }
        });

        setAlreadyAssignedIds(assignedIds);
        setSelectedItemIds((prev) => [...new Set([...prev, ...assignedIds])]);
        setMapping((prev) => ({ ...prev, ...newMapping }));
      } catch (error) {
        console.error("Fetch Already Assigned LS2s Error:", error);
      }
    };

    fetchAssignedLs2();
  }, [formId, resolvedProjectId, isLs2Department]);

  useEffect(() => {
    if (!selectedLs1Id && ls1Items.length > 0) {
      setSelectedLs1Id(ls1Items[0]._id);
    }
  }, [ls1Items, selectedLs1Id]);

  useEffect(() => {
    if (!selectedLs1Id && defaultLs1Id) {
      setSelectedLs1Id(defaultLs1Id);
    }
  }, [defaultLs1Id, selectedLs1Id]);

  useEffect(() => {
    const fetchLs2Items = async () => {
      const ls1Id = getIdValue(selectedLs1Id || defaultLs1Id);
      setLoading(true);
      try {
        const itemsUrl = isLs2Department
          ? API_URLS.GET_DEPARTMENTS_BY_LOCATION(ls1Id)
          : API_URLS.GET_LOCATIONS_BY_DEPARTMENT(ls1Id);
        const itemsResponse = await getApi({ apiUrl: itemsUrl });
        setItems(itemsResponse?.data?.data || itemsResponse?.data || []);
      } catch (error) {
        console.error("LS2 Items Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLs2Items();
  }, [selectedLs1Id, defaultLs1Id, isLs2Department]);

  useEffect(() => {
    const fetchUsersForItems = async () => {
      const ls1Id = getIdValue(selectedLs1Id || defaultLs1Id);
      if (items.length === 0) {
        setUsersByItem({});
        setUsersReady(true);
        return;
      }
      setUsersReady(false);
      try {
        const entries = await Promise.all(
          items.map(async (item) => {
            const locationId = isLs2Department ? ls1Id : item._id;
            const departmentId = isLs2Department ? item._id : ls1Id;
            const usersResponse = await getApi({
              apiUrl: API_URLS.GET_EMPLOYEES_BY_SCOPE({
                locationId,
                departmentId,
                role: "",
                projectId: resolvedProjectId || "",
                formId: formId || "",
                isUnassigned: false,
              }),
            });
            return [
              item._id,
              usersResponse?.data?.data || usersResponse?.data || [],
            ];
          }),
        );
        setUsersByItem(Object.fromEntries(entries));
      } catch (error) {
        console.error("Users Fetch Error:", error);
      } finally {
        setUsersReady(true);
      }
    };
    fetchUsersForItems();
  }, [items, selectedLs1Id, defaultLs1Id, isLs2Department]);

  const handleUserChange = (itemId, userId) => {
    setMapping((prev) => ({
      ...prev,
      [itemId]: { ...prev[itemId], userId },
    }));
  };

  const handleSectionChange = (itemId, sectionIds) => {
    setMapping((prev) => ({
      ...prev,
      [itemId]: { ...prev[itemId], sections: sectionIds },
    }));
  };

  const proceedToSave = async () => {
    const payload = {
      formId: formId,
      formType: formType || "standard",
      allotmentType: "handle",
      projectId: resolvedProjectId,
      targets: selectedItemIds
        .filter((itemId) => !alreadyAssignedIds.includes(itemId))
        .map((itemId) => {
          const ls1Id = getIdValue(selectedLs1Id || defaultLs1Id);
          const normalizedItemId = getIdValue(itemId);
          const normalizedUserId = getIdValue(mapping[itemId]?.userId);
          return {
            locationId: isLs2Department ? ls1Id : normalizedItemId,
            departmentId: isLs2Department ? normalizedItemId : ls1Id,
            employeeId: normalizedUserId,
            sections: getSectionIdValues(mapping[itemId]?.sections),
          };
        }),
    };

    console.log("LS2 Hierarchy Allotment Payload:", payload);

    setLoading(true);
    setShowConfirmModal(false);
    try {
      const response = await postApi({
        apiUrl: API_URLS.AUTHORIZE_HIERARCHY_LS2,
        data: payload,
      });

      if (
        response?.success ||
        response?.status === 200 ||
        response?.status === 201
      ) {
        dispatch(
          fetchFormAssignments({
            formId,
            isEmployee: true,
            projectId: resolvedProjectId,
          }),
        );
        setPopupConfig({
          type: "success",
          title: "Success",
          message: "Form authorization successfully!",
        });
      } else {
        throw new Error(
          response?.data?.message ||
            response?.message ||
            "Failed to save LS2 hierarchy.",
        );
      }
    } catch (error) {
      console.error("LS2 Save Error:", error);
      setPopupConfig({
        type: "error",
        title: "Error",
        message: error.message || "Failed to save LS2 hierarchy.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!popupConfig) return undefined;

    if (popupTimeoutRef.current) {
      clearTimeout(popupTimeoutRef.current);
    }

    const timeoutMs = popupConfig.type === "success" ? 2000 : 3000;
    popupTimeoutRef.current = setTimeout(() => {
      setPopupConfig(null);

      if (popupConfig.type === "success" && onClose) {
        onClose();
      }
    }, timeoutMs);

    return () => {
      if (popupTimeoutRef.current) {
        clearTimeout(popupTimeoutRef.current);
      }
    };
  }, [popupConfig, onClose]);

  const handleSave = () => {
    const newSelections = selectedItemIds.filter(
      (id) => !alreadyAssignedIds.includes(id),
    );
    if (newSelections.length === 0) {
      message.warning("Please select at least one item.");
      return;
    }

    // Check for missing supervisors
    const missingSupervisors = newSelections.filter(
      (itemId) => !mapping[itemId]?.userId,
    );
    if (missingSupervisors.length > 0) {
      message.warning("Please assign a supervisor for all selected items.");
      return;
    }

    setShowConfirmModal(true);
  };

  useEffect(() => {
    if (reduxSuccess) {
      setPopupConfig({
        type: "success",
        title: "Success",
        message: "LS2 Authorizations mapped successfully!",
      });
      dispatch(clearStatus());
    }
    if (reduxError) {
      setPopupConfig({
        type: "error",
        title: "Error",
        message: reduxError,
      });
      dispatch(clearStatus());
    }
  }, [reduxSuccess, reduxError, dispatch, onClose]);

  useEffect(() => {
    return () => {
      if (popupTimeoutRef.current) {
        clearTimeout(popupTimeoutRef.current);
      }
    };
  }, []);

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedItemIds((prev) => {
        const nonAssignedIds = items
          .map((item) => item._id)
          .filter((id) => !alreadyAssignedIds.includes(id));
        return [...new Set([...prev, ...nonAssignedIds])];
      });
    } else {
      const itemIds = items.map((item) => item._id);
      setSelectedItemIds((prev) =>
        prev.filter(
          (id) => alreadyAssignedIds.includes(id) || !itemIds.includes(id),
        ),
      );
    }
  };

  const filteredItems = useMemo(() => {
    return items.filter((d) => {
      const name = isLs2Department
        ? d.department_name || d.name
        : d.location_name || d.name;
      return name?.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [items, searchTerm, isLs2Department]);

  // Filter users dynamically based on org structure
  const getUsersForItem = (itemId) => {
    return usersByItem[itemId] || [];
  };

  const paginatedItems = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredItems.slice(startIndex, startIndex + pageSize);
  }, [filteredItems, currentPage, pageSize]);

  const selectedPairs = useMemo(() => {
    return selectedItemIds
      .filter((itemId) => !alreadyAssignedIds.includes(itemId))
      .map((itemId) => {
        const item = items.find((i) => i._id === itemId);
        const itemName = isLs2Department
          ? item?.department_name || item?.name
          : item?.location_name || item?.name;
        const user = (usersByItem[itemId] || []).find(
          (u) => u._id === mapping[itemId]?.userId,
        );

        const selectedSectionNames = (mapping[itemId]?.sections || [])
          .map((id) => sections.find((s) => s.sectionId === id)?.name)
          .filter(Boolean)
          .join(", ");

        return {
          id: itemId,
          itemName,
          userName: user?.name || "N/A",
          sectionNames: selectedSectionNames || "All Sections",
        };
      });
  }, [
    selectedItemIds,
    items,
    mapping,
    usersByItem,
    isLs2Department,
    sections,
    alreadyAssignedIds,
  ]);

  const totalPages = Math.ceil(filteredItems.length / pageSize);

  return (
    <div className="m-2 border border-[#8ac7bb] rounded-2xl overflow-hidden bg-white shadow-sm">
      {/* Header Controls */}
      <div className="flex items-center justify-between p-6 border-b border-[#8ac7bb] bg-[#FBFDFD]">
        <label className="authorize-selectall  flex gap-2 items-center text-[#06513D] text-xs font-semibold px-3 py-2 rounded-lg uppercase tracking-wide">
          <input
            type="checkbox"
            // className="flex items-center gap-2 px-8 py-2.5 border border-gray-300 rounded-xl cursor-pointer hover:bg-gray-50 transition-all font-bold text-gray-700 text-xs tracking-wider"
            onClick={() => {
              const selectableItems = items.filter(
                (item) => !alreadyAssignedIds.includes(item._id),
              );
              const allSelected =
                selectableItems.length > 0 &&
                selectableItems.every((item) =>
                  selectedItemIds.includes(item._id),
                );
              handleSelectAll(!allSelected);
            }}
          />
          SELECT All
        </label>
        <div className="relative w-[340px]">
          <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl" />
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="w-full h-11 pl-12 pr-4 bg-white border border-gray-200 rounded-xl focus:outline-none focus:ring-1 focus:ring-[#06513D]/20 transition-all font-medium"
          />
        </div>
      </div>
      <div className="grid grid-cols-[1.2fr_0.2fr_1.2fr_1.2fr]  gap-8 mb-8 py-2 border-b border-[#8ac7bb] ">
        <div className="flex items-center justify-center text-lg font-bold text-gray-800">
          {isLs2Department ? "Department" : "Location"}
        </div>
        <div></div>
        <div className="flex items-center justify-center text-lg font-bold text-gray-800">
          Assign Supervisor
        </div>
        <div className="flex items-center justify-center text-lg font-bold text-gray-800">
          Select Form Section
        </div>
      </div>
      <div className="p-6">
        {/* Column Headers */}

        {/* List */}
        <div className="space-y-6  px-2">
          {!selectedLs1Id ? (
            <div className="text-center py-16 text-gray-400 font-medium italic">
              Please select {isLs2Department ? "a location" : "a department"} to
              continue.
            </div>
          ) : (
            paginatedItems.map((item) => {
              const itemId = item._id;
              const itemName = isLs2Department
                ? item.department_name || item.name
                : item.location_name || item.name;
              const linkedUsers = getUsersForItem(itemId);

              return (
                <div
                  key={itemId}
                  className="grid grid-cols-[1.2fr_0.2fr_1.2fr_1.2fr] gap-8 items-center animate-fadeIn"
                >
                  <div className="flex items-center gap-4">
                    {alreadyAssignedIds.includes(itemId) ? (
                      <div className="scale-125 w-[16px] h-[16px] bg-[#06513D] rounded-[4px] flex items-center justify-center">
                        <IoCheckmark className="text-white text-xs font-bold" />
                      </div>
                    ) : (
                      <Checkbox
                        checked={selectedItemIds.includes(itemId)}
                        onChange={(e) => {
                          setSelectedItemIds((prev) =>
                            e.target.checked
                              ? [...prev, itemId]
                              : prev.filter((i) => i !== itemId),
                          );
                        }}
                        className="custom-green-checkbox scale-125"
                      />
                    )}
                    <div
                      className={`flex-1 h-12 bg-white border border-[#3BA2B9] rounded-xl flex items-center px-4 shadow-sm ${alreadyAssignedIds.includes(itemId) ? "opacity-75" : ""}`}
                    >
                      <span className="font-medium text-gray-700 truncate">
                        {itemName}
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-center text-[#06513D] text-2xl">
                    <FaArrowRightLong />
                  </div>

                  <div className="relative">
                    <Select
                      placeholder="Users Picklist 1"
                      className="w-full h-12 custom-mapping-select text-[13px]"
                      value={
                        usersReady
                          ? mapping[itemId]?.userId || undefined
                          : undefined
                      }
                      onChange={(val) => handleUserChange(itemId, val)}
                      dropdownStyle={{ borderRadius: "12px" }}
                      showSearch
                      optionFilterProp="children"
                      disabled={alreadyAssignedIds.includes(itemId)}
                      loading={!usersReady}
                      suffixIcon={
                        <IoChevronDown className="text-cyan-600 text-lg" />
                      }
                    >
                      {linkedUsers.map((u) => (
                        <Option key={u._id} value={u._id}>
                          {u.name}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="relative">
                    <Select
                      mode="multiple"
                      placeholder="Select Form Section"
                      className="w-full h-12 custom-mapping-select text-[13px]"
                      value={usersReady ? mapping[itemId]?.sections || [] : []}
                      onChange={(val) => handleSectionChange(itemId, val)}
                      maxTagCount="responsive"
                      showSearch
                      dropdownStyle={{ borderRadius: "12px" }}
                      disabled={alreadyAssignedIds.includes(itemId)}
                      loading={!usersReady}
                      suffixIcon={
                        <IoChevronDown className="text-cyan-600 text-lg" />
                      }
                    >
                      {sections.map((s) => (
                        <Option key={s.sectionId} value={s.sectionId}>
                          {s.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-10 mt-12 mb-8">
          <button
            onClick={onClose}
            className="px-16 py-3 border border-[#06513D] text-[#06513D] bg-[#E6EDEB] hover:bg-[#F8F8F8] rounded-xl font-bold  min-w-[180px]"
          >
            Back
          </button>
          <button
            onClick={handleSave}
            disabled={loading}
            className="px-16 py-3 bg-[#06513D] hover:bg-[#387464] text-white rounded-xl font-bold shadow-lg hover:shadow-xl  disabled:opacity-50 min-w-[180px]"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-100 text-sm text-gray-500 font-medium">
          <div className="flex items-center gap-3">
            <span>Showing</span>
            <Select
              value={pageSize}
              onChange={(val) => {
                setPageSize(val);
                setCurrentPage(1);
              }}
              className="w-20 rounded-lg custom-pagination-select"
              suffixIcon={<IoChevronDown className="text-gray-600" />}
            >
              {[4, 10, 20, 50].map((size) => (
                <Option key={size} value={size}>
                  {size}
                </Option>
              ))}
            </Select>
          </div>

          <div>
            Showing {(currentPage - 1) * pageSize + 1} to{" "}
            {Math.min(currentPage * pageSize, filteredItems.length)} out of{" "}
            {filteredItems.length} records
          </div>

          <div className="flex items-center gap-4">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}
              className="p-1 disabled:opacity-30 hover:bg-gray-100 rounded transition-colors"
            >
              <LeftOutlined />
            </button>

            <div className="flex items-center gap-1">
              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(
                  (p) =>
                    p === 1 ||
                    p === totalPages ||
                    Math.abs(p - currentPage) <= 1,
                )
                .map((p, index, array) => {
                  const showEllipsis = index > 0 && p !== array[index - 1] + 1;
                  return (
                    <React.Fragment key={p}>
                      {showEllipsis && <span className="px-2">...</span>}
                      <button
                        onClick={() => setCurrentPage(p)}
                        className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
                          currentPage === p
                            ? "border border-[#06513D] text-[#06513D] font-bold"
                            : "text-gray-400 hover:text-gray-700"
                        }`}
                      >
                        {p}
                      </button>
                    </React.Fragment>
                  );
                })}
            </div>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)}
              className="p-1 disabled:opacity-30 hover:bg-gray-100 rounded transition-colors"
            >
              <RightOutlined />
            </button>
          </div>
        </div>
      </div>

      {/* Popup Notification */}
      {popupConfig && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn">
          <PopupCard
            type={popupConfig.type}
            title={popupConfig.title}
            message={popupConfig.message}
          />
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeInFast">
          <div className="bg-white rounded-[32px] w-[90%] max-w-[800px] overflow-hidden shadow-2xl animate-scaleUp">
            <div className="p-8 md:p-12">
              <h2 className="text-3xl font-bold text-[#06513D] text-center mb-8">
                Confirmation
              </h2>

              <div className="border border-[#8ac7bb] rounded-[24px] p-8 min-h-[300px] bg-[#f9fbfa]">
                <h3 className="text-2xl font-bold text-[#06513D] mb-8">
                  {selectedPairs.length}{" "}
                  {isLs2Department ? "Departments" : "Locations"} Selected
                </h3>

                <div className="grid grid-cols-1 gap-y-6 max-h-[400px] overflow-y-auto pr-4 custom-scrollbar">
                  {selectedPairs.map((pair) => (
                    <div
                      key={pair.id}
                      className="grid grid-cols-[1fr_1fr_1.2fr] gap-6 text-xl text-gray-700 font-medium"
                    >
                      <span className="truncate">{pair.itemName}</span>
                      <span className="truncate">{pair.userName}</span>
                      <span className="truncate ">{pair.sectionNames}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-10 flex justify-center gap-8">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="flex-1 max-w-[200px] py-4 rounded-2xl border-2 border-[#06513D]/20 bg-[#E6F4EA] text-[#06513D] font-bold text-xl hover:bg-[#D7EADD] transition-all active:scale-95"
                >
                  Back
                </button>
                <button
                  onClick={proceedToSave}
                  disabled={loading}
                  className="flex-1 max-w-[200px] py-4 rounded-2xl bg-[#06513D] text-white font-bold text-xl hover:bg-[#054031] transition-all shadow-lg active:scale-95"
                >
                  {loading ? "Processing..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style
        dangerouslySetInnerHTML={{
          __html: `
                .custom-mapping-select .ant-select-selector {
                    border-radius: 12px !important;
                    border: 1px solid #3BA2B9 !important;
                    height: 48px !important;
                    display: flex !important;
                    align-items: center !important;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
                }
                .custom-mapping-select .ant-select-selection-placeholder {
                    display: flex !important;
                    align-items: center !important;
                }
                .custom-mapping-select .ant-select-selection-item {
                    display: flex !important;
                    align-items: center !important;
                    margin-top: 0 !important;
                    margin-bottom: 0 !important;
                }
                .custom-mapping-select .ant-select-selection-overflow {
                    display: flex !important;
                    align-items: center !important;
                    height: 100% !important;
                }
                .custom-pagination-select .ant-select-selector {
                    border-radius: 8px !important;
                    border: 1px solid #E5E7EB !important;
                    height: 32px !important;
                    display: flex !important;
                    align-items: center !important;
                }
                .custom-green-checkbox .ant-checkbox-checked .ant-checkbox-inner {
                    background-color: #06513D !important;
                    border-color: #06513D !important;
                }
                .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #06513D30; border-radius: 10px; }

                @keyframes fadeInFast {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                .animate-fadeInFast {
                    animation: fadeInFast 0.2s ease-out forwards;
                }

                @keyframes scaleUp {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
                .animate-scaleUp {
                    animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                }
            `,
        }}
      />
    </div>
  );
};

export default AuthorizeToManageLS2;
